import { createGlobalStyle } from 'styled-components';
import { colors } from './variables';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Noto Sans KR', sans-serif;
  }
  
  html {
    scroll-padding-top: 80px; /* 헤더 높이만큼 여백 추가 */
  }
  
  body {
    background-color: ${colors.white};
    color: ${colors.primary};
    line-height: 1.5;
    font-weight: 400;
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
  
  ul, ol {
    list-style: none;
  }
  
  button {
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
`;

export default GlobalStyle;